export default __webpack_public_path__ + "static/10.03-1-384a2d2f68075808f3e7f1a1688fe310.png";